export const ARROW_LENGTH_SCALE = 1;
export const ARROW_WIDTH_SCALE = 2;

export function resolveArrowDimensions(markerSize, strokeWidth = 1) {
  const size = Number(markerSize);
  const resolvedSize = Number.isFinite(size) && size > 0
    ? size
    : Math.max(8, Number(strokeWidth) * 3.5 || 8);
  return {
    length: resolvedSize * ARROW_LENGTH_SCALE,
    halfWidth: resolvedSize * 0.48 * ARROW_WIDTH_SCALE,
  };
}

export function arrowStrokeTerminalGap(strokeWidth) {
  const width = Number(strokeWidth);
  // Round line caps extend by half the stroke width. Leave an additional
  // half-width of clearance so the stroke cannot visually run past the arrow
  // tip or flatten its point.
  return Math.max(1, (Number.isFinite(width) ? width : 1) * 1.25);
}

export function shortenBezierEndpoint(points, gap) {
  if (!Array.isArray(points) || points.length < 4) return points;
  const end = points[3];
  const control = points[2];
  const dx = end.x - control.x;
  const dy = end.y - control.y;
  const length = Math.hypot(dx, dy) || 1;
  const distance = Math.min(Math.max(0, Number(gap) || 0), length * 0.45);
  return [
    points[0],
    points[1],
    points[2],
    { x: end.x - (dx / length) * distance, y: end.y - (dy / length) * distance },
  ];
}
